// @flow

import ReactGA from 'react-ga';

import { DEPLOYMENT_ENVIRONMENT } from 'shared/config';

export default () => {
  if (!DEPLOYMENT_ENVIRONMENT || DEPLOYMENT_ENVIRONMENT === 'local') return;

  if (document.body) {
    document.body.addEventListener('click', (event: MouseEvent) => {
      const element = (event.target: any);

      if (!element.matches('[data-ga-category]')) return;

      const options = element.dataset;

      if (options.gaCategory && options.gaAction && options.gaLabel) {
        ReactGA.event({
          category: options.gaCategory,
          action: options.gaAction,
          label: options.gaLabel
        });
      }
    });
  }
};
